import { useTheme } from '@material-ui/core';
import React from 'react';
import { ISale } from 'gen/ApiClient';
import { SalesCreditChipOrFragment } from './SalesCreditChipOrFragment';
import { SalesPaymentStatusChip } from './SalesPaymentStatusChip';

interface IProps {
	item: ISale;
	style?: React.CSSProperties;
}

export const SalesPaymentStatusAndCreditChips = ({ item, style }: IProps) => {
	const theme = useTheme();

	return (
		<div
			className='df-row-ac'
			style={style}>
			<SalesPaymentStatusChip
				item={item}
				style={{ marginRight: theme.spacing(1) }}
			/>
			<SalesCreditChipOrFragment item={item} />
		</div>
	);
};
